import React from "react";

export default function Footer() {
  return (
    <footer className="w-full shrink-0 border-t border-[#F4D03F]/20 bg-[#0A1128] px-4 py-2.5 text-center text-[11px] tracking-wide text-white/60">
      Designed and managed by{" "}
      <span className="font-semibold text-[#F4D03F]">TPEPS Technologies</span>
    </footer>
  );
}